import curd from '../curd'

const BASE_PATH = '/task/device'

export default curd(BASE_PATH, {
  save: model => ({
    url: `${BASE_PATH}/save/one`,
    method: 'POST',
    data: model
  }),
  submit: taskId => ({
    url: `/task/device/submit/${taskId}`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/TaskDevice.js